var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditInline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.27384 11.802L0.192518 17.7842L0.0198881 18.2808C-0.0743078 18.5527 0.18201 18.8091 0.453902 18.7149L0.950589 18.5422L6.93278 16.4609C6.972 16.4478 7.00859 16.427 7.0373 16.3982L2.33651 11.6973C2.3078 11.7262 2.28678 11.7628 2.27384 11.802Z",
    fill: "#202D34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0799 2.2061L16.5268 0.652992C15.6561 -0.217664 14.2441 -0.217664 13.3735 0.652992L11.8125 2.21398L16.5187 6.92021L18.0797 5.35922C18.9506 4.48875 18.9506 3.07694 18.0799 2.2061Z",
    fill: "#202D34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0309 2.99862L3.11914 10.9104L7.82534 15.6166L15.7371 7.70482L11.0309 2.99862Z",
    fill: "#202D34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditInline);
export default __webpack_public_path__ + "static/media/edit_inline.6a41b9156640d508b1d2f6132c7be62b.svg";
export { ForwardRef as ReactComponent };